module.exports = __webpack_public_path__ + "img/58.df57e6e3.jpg";